import api from './api';

// Forza /index.php in base URL (solo per pagamenti)
export const pagamentiGetCentro = (cantiereId) =>
    api.get(`/pagamenti/centro/${cantiereId}`);

export const pagamentiSaveCentro = (cantiereId, centro) =>
    api.post(`/pagamenti/centro/${cantiereId}`, { centro_costo: centro });

export const pagamentiFetch = (cantiereId, refresh = false) =>
    api.get(`/pagamenti/${cantiereId}${refresh ? '?refresh=true' : ''}`);